import {
  collection,
  doc,
  type Firestore,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import { modelItemStream } from '../../firestore-mobx/stream'
import type { FirebaseRepository } from '../../models/FirebaseRepository'
import { buildUnsupportedConverter } from '../shared/noops'
import type { FirestoreSettingsKillSwitch } from './schema'
import { schema } from './schema'
import { SettingsKillSwitch } from '../../models/SettingsKillSwitch'

const unsupported = buildUnsupportedConverter<FirestoreSettingsKillSwitch>()

const converter: FirestoreDataConverter<FirestoreSettingsKillSwitch> = {
  toFirestore: unsupported.toFirestore,
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    return schema.parse(snapshot.data())
  },
}

export const getDocRef = (firestore: Firestore) => {
  return doc(collection(firestore, 'settings'), 'kill_switch').withConverter(
    converter
  )
}

export const getSettingsKillSwitch = (repository: FirebaseRepository) => {
  const docRef = getDocRef(repository.firestore)

  return modelItemStream(repository, docRef, SettingsKillSwitch)
}
